import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1320px] flex-col items-center px-4 py-24 text-center md:px-8">
        <span className="font-heading text-[80px] leading-none text-background-300 md:text-[120px]">
          404
        </span>
        <h1 className="mt-4 font-heading text-xl text-foreground-950">页面不存在</h1>
        <p className="mt-2 text-sm text-foreground-500">
          你访问的地址可能已被调整，或内容已经下架。
        </p>
        <p className="mt-1 font-mono text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row">
          <Link
            to="/"
            className="flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/category"
            className="flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-grid-line" />
            浏览电影分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}